import React from 'react';
import {
  Box, Card, CardContent, Typography, Divider, Button, Avatar, Stack,
  IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TableFooter
} from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import RejectPaymentModal from '../components/PaymentRequestData/RejectPaymentModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchPaymentRequestDetails, paymentRequestMarkAsPaid } from '../api/paymentRequestApi';
import { useNotification } from '../hooks/useNotification';
import { BackArrowIcon } from '../icons';
import { getShortFormat } from '../utils/helperFunction';

const PaymentRequestDetails = ({backUrl}) => {
  const { transactionId } = useParams()
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = React.useState(false);
  const { showErrorNotification,showSuccessNotification } = useNotification()
  const resolvedBackUrl = location.state?.backUrl || backUrl;



  const fetchDetails = () => {
    fetchPaymentRequestDetails({ setDetails, transactionId, setLoading })
      .catch(error => {
        showErrorNotification(error?.message)
      })
  }

  React.useEffect(() => {
    if (transactionId) {
      fetchDetails()
    }
  }, [])

  const handleMarkAsPaid = ()=>{
    if(details?.id){
      paymentRequestMarkAsPaid({transactionId:details?.id,setSaving})
      .then(result=>{
         showSuccessNotification(result?.message || "Marked as paid")
         fetchDetails()
      })
      .catch(error=>{
       showErrorNotification(error?.message)
      })
    }
  }

  const handleBack = (e) => {
    e.preventDefault();
    if (resolvedBackUrl === -1) {
      navigate(-1);
    } else if (typeof resolvedBackUrl === 'string') {
      navigate(resolvedBackUrl, { state: { backUrl: location?.pathname, activeTab: location?.state?.activeTab } });
    } else {
      navigate(-1);
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
      <div className="col">
        <Typography
          gutterBottom
          color="#1e1e1e"
          sx={{
            mb: 2,
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#15243E',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <IconButton onClick={handleBack} size="small" aria-label="Back">
            <BackArrowIcon />
          </IconButton>
          Payment Request Details
        </Typography>
      </div>

      <Grid container spacing={2}>
        {/* Student Profile */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, }}>
                <Typography color="#1e1e1e" sx={{ mb: 0, fontSize: '16px', fontWeight: 'bold', }} gutterBottom>
                  Student Profile
                </Typography>
                <Typography variant="span" sx={{ mb: 0, fontSize: '12px', fontWeight: '400', color: '#858585' }}>
                  Joined: {details?.studentJoined}
                </Typography>
              </Box>

              <Box mt={2} display="flex" alignItems="center" gap={2} justifyContent="space-between">
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar sx={{ width: '60px', height: '60px', objectFit: 'cover', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getShortFormat(details?.studentName)}</Avatar>
                  <Box>
                    <Typography sx={{ mb: 0, fontSize: '16px', fontWeight: '600', color: '#1e1e1e' }}>
                      {details?.studentName}
                    </Typography>
                    <Typography variant="body2" sx={{ my: 0.3, fontSize: '12px', fontWeight: '400', color: '#858585' }}>Student ID: <Typography variant='span'>{details?.studentId}</Typography></Typography>
                    <Typography variant="body2" sx={{ my: 0.3, fontSize: '12px', fontWeight: '400', color: '#858585' }}>Mobile: + {details?.studentPhone}</Typography>
                    <Typography variant="body2" sx={{ my: 0.3, fontSize: '12px', fontWeight: '400', color: '#858585' }}>Email: {details?.studentEmail}</Typography>
                  </Box>
                </Box>
                {/* <IconButton sx={{ background: 'rgba(20, 174, 92, 0.08)', color: 'rgba(20, 174, 92, 1)', fontSize: '12px', borderRadius: '3px', px: 2, py: 0.5, fontWeight: '600', }}>Verified</IconButton> */}
              </Box>
            </CardContent>
          </Card>

          {/* Payment Method */}
          <Card sx={{ mt: 2 }}>
            <CardContent>
              <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1e1e1e', mb: 1.5 }} gutterBottom>
                Payment Method
              </Typography>
              <Stack spacing={1}>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Bank Payment <Typography variant='span'></Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Payee Name: <Typography variant='span'> {details?.bankHolderName}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Bank Name: <Typography variant='span'>{details?.bankName}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Account No.: <Typography variant='span'>{details?.bankAccountNo}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>IFSC: <Typography variant='span'>{details?.bankIfscCode}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Branch: <Typography variant='span'>{details?.bankBranchName}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Bank Address: <Typography variant='span'>{details?.bankAddress}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>City: <Typography variant='span'>{details?.bankCity}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>Account Type: <Typography variant='span'>{details?.bankAccountType}</Typography></Typography>
                <Typography sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))', color: '#3e495d', fontSize: '14px', fontWeight: '500' }}>PAN No.: <Typography variant='span'>{details?.bankHolderPanNo}</Typography></Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Payment Breakdown */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1e1e1e', mb: 1.5 }}>
                    Payment Breakdown
                  </Typography>
                </Box>
                <Box color="green" sx={{
                  display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.5, background: 'rgba(20, 174, 92, 0.08)', color: '#1e1e1e', fontSize: '14px', borderRadius: '8px', px: 2, py: 0.5, fontWeight: '600', border: '1px solid rgba(20, 174, 92, 1)',

                }}>
                  Referral Bonus: <Typography variant='span' sx={{ fontSize: '24px', fontWeight: 'bold' }}>{details?.withdrawalAmount}</Typography>
                </Box>
              </Box>

              <Box mt={2}>
                <Typography variant="body2" fontWeight="bold">
                  Admission Details:
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Referred Students Table */}
              <TableContainer component={Paper} elevation={0} sx={{ boxShadow: 'none' }}>
                <Table size="small" aria-label="referral table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', background: 'rgba(52, 94, 255, 1)', color: '#fff', fontSize: '14px', py: 1.5 }}>Referred Student</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', background: 'rgba(52, 94, 255, 1)', color: '#fff', fontSize: '14px', py: 1.5 }}>Course</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', background: 'rgba(52, 94, 255, 1)', color: '#fff', fontSize: '14px', py: 1.5 }}>Specialization</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', background: 'rgba(52, 94, 255, 1)', color: '#fff', fontSize: '14px', py: 1.5 }}>University</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', background: 'rgba(52, 94, 255, 1)', color: '#fff', fontSize: '14px', py: 1.5 }}>Bonus</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {details?.referrals?.map((student, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ fontWeight: '500', color: '#505050', fontSize: '12px', py: 1.5 }}>
                          {student.name} • <Typography variant='span' sx={{ fontWeight: '600' }}>{student.id}</Typography>
                        </TableCell>
                        <TableCell sx={{ fontWeight: '500', color: '#505050', fontSize: '12px', py: 1.5 }}>{student.course}</TableCell>
                        <TableCell sx={{ fontWeight: '500', color: '#505050', fontSize: '12px', py: 1.5 }}>{student.specialization}</TableCell>
                        <TableCell sx={{ fontWeight: '500', color: '#505050', fontSize: '12px', py: 1.5 }}>{student.university}</TableCell>
                        <TableCell sx={{ fontWeight: '500', color: '#505050', fontSize: '12px', py: 1.5 }}>{student.bonus}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                  {/* ✅ Table Footer */}
                  <TableFooter>
                    <TableRow>
                      <TableCell colSpan={4} sx={{ textAlign: 'right', fontWeight: 'bold', fontSize: '14px', color: '#1e1e1e', py: 1.5 }}>
                        Total Referral Bonus:
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: 'green', py: 1.5 }}>
                        {details?.totalReferralAmt}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>



              <Divider sx={{ my: 2 }} />

              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography fontWeight="bold">Total Amount</Typography>
                <Typography variant="h6" color="primary">
                  {details?.withdrawalAmount}
                </Typography>
              </Box>

              <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                {details?.status==="Pending" && <Button disabled={saving} sx={{ background: '#F4413D', color: '#fff', textTransform: 'capitalize', py: 0.7, px: 2.5 }} onClick={() => setIsRejectModalOpen(true)}>
                  Reject Request
                </Button>}
                {details?.status==="Pending" && <Button disabled={saving} loading={saving} onClick={handleMarkAsPaid} sx={{ background: '#0B57D0', color: '#fff', textTransform: 'capitalize', py: 0.7, px: 2.5 }}>
                  Mark as Paid
                </Button>}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <RejectPaymentModal
        id={details?.id}
        open={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        refetch={fetchDetails}
      />
    </Box>
  )
}

export default PaymentRequestDetails





